(function () {
  'use strict';

  // Localised UI strings published by theme.liquid.
  function s(key) {
    return (window.eclatStrings && window.eclatStrings[key]) || '';
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initGridToggle();
    initFilterToggle();
    initSortDropdown();
  });

  /* ── GRID TOGGLE — 4/5/6 columns with dot-grid icons ── */
  function initGridToggle() {
    var container = document.getElementById('EclatGridToggle');
    var grid = document.getElementById('product-grid');
    if (!container || !grid) return;

    var icons = {
      4: '<svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><rect x="0" y="0" width="7" height="7"/><rect x="9" y="0" width="7" height="7"/><rect x="0" y="9" width="7" height="7"/><rect x="9" y="9" width="7" height="7"/></svg>',
      5: '<svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><rect x="0" y="0" width="4" height="4"/><rect x="6" y="0" width="4" height="4"/><rect x="12" y="0" width="4" height="4"/><rect x="0" y="6" width="4" height="4"/><rect x="6" y="6" width="4" height="4"/><rect x="12" y="6" width="4" height="4"/><rect x="0" y="12" width="4" height="4"/><rect x="6" y="12" width="4" height="4"/><rect x="12" y="12" width="4" height="4"/></svg>',
      6: '<svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><rect x="0" y="0" width="2.5" height="2.5"/><rect x="4.5" y="0" width="2.5" height="2.5"/><rect x="9" y="0" width="2.5" height="2.5"/><rect x="13.5" y="0" width="2.5" height="2.5"/><rect x="0" y="4.5" width="2.5" height="2.5"/><rect x="4.5" y="4.5" width="2.5" height="2.5"/><rect x="9" y="4.5" width="2.5" height="2.5"/><rect x="13.5" y="4.5" width="2.5" height="2.5"/><rect x="0" y="9" width="2.5" height="2.5"/><rect x="4.5" y="9" width="2.5" height="2.5"/><rect x="9" y="9" width="2.5" height="2.5"/><rect x="13.5" y="9" width="2.5" height="2.5"/><rect x="0" y="13.5" width="2.5" height="2.5"/><rect x="4.5" y="13.5" width="2.5" height="2.5"/><rect x="9" y="13.5" width="2.5" height="2.5"/><rect x="13.5" y="13.5" width="2.5" height="2.5"/></svg>'
    };

    var currentCols = 4;
    if (grid.classList.contains('grid--5-col-desktop')) currentCols = 5;
    if (grid.classList.contains('grid--6-col-desktop')) currentCols = 6;

    var wrap = document.createElement('div');
    wrap.className = 'eclat-grid-toggle';

    [4, 5, 6].forEach(function (cols) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'eclat-grid-toggle__btn' + (cols === currentCols ? ' is-active' : '');
      btn.setAttribute('aria-label', s('columns').replace('[count]', cols));
      btn.innerHTML = icons[cols];
      btn.addEventListener('click', function () {
        grid.classList.remove('grid--4-col-desktop', 'grid--5-col-desktop', 'grid--6-col-desktop');
        grid.classList.add('grid--' + cols + '-col-desktop');
        currentCols = cols;
        wrap.querySelectorAll('.eclat-grid-toggle__btn').forEach(function (button) {
          button.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
      wrap.appendChild(btn);
    });

    container.appendChild(wrap);
  }

  /* ── FILTER TOGGLE ── */
  function initFilterToggle() {
    var btn = document.getElementById('EclatFilterToggle');
    var sidebar = document.querySelector('.facets-vertical');
    if (!btn || !sidebar) return;

    var textEl = btn.querySelector('.eclat-toggle-text');
    var isHidden = false;

    btn.addEventListener('click', function () {
      isHidden = !isHidden;
      sidebar.classList.toggle('eclat-filters-hidden', isHidden);
      if (textEl) textEl.textContent = isHidden ? s('showFilters') : s('hideFilters');
      btn.setAttribute('aria-expanded', String(!isHidden));
    });
  }

  /* ── SORT DROPDOWN — URL redirect for reliable sorting ── */
  function initSortDropdown() {
    var sortBtn = document.getElementById('EclatSortBtn');
    var dropdown = document.getElementById('EclatSortDropdown');
    var sortLabel = document.getElementById('EclatSortLabel');
    if (!sortBtn || !dropdown) return;

    sortBtn.addEventListener('click', function (event) {
      event.stopPropagation();
      var isOpen = !dropdown.hasAttribute('hidden');
      if (isOpen) {
        dropdown.setAttribute('hidden', '');
        sortBtn.setAttribute('aria-expanded', 'false');
      } else {
        dropdown.removeAttribute('hidden');
        sortBtn.setAttribute('aria-expanded', 'true');
      }
    });

    dropdown.addEventListener('click', function (event) {
      event.stopPropagation();
      var option = event.target.closest('.eclat-sort-option');
      if (!option) return;

      var value = option.dataset.value;
      if (sortLabel) sortLabel.textContent = option.textContent.trim();

      dropdown.querySelectorAll('.eclat-sort-option').forEach(function (item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-selected', 'false');
      });
      option.classList.add('is-active');
      option.setAttribute('aria-selected', 'true');

      dropdown.setAttribute('hidden', '');
      sortBtn.setAttribute('aria-expanded', 'false');

      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.location.href = url.toString();
    });

    document.addEventListener('click', function () {
      if (!dropdown.hasAttribute('hidden')) {
        dropdown.setAttribute('hidden', '');
        sortBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

})();

(function () {
  'use strict';

  function showSecondaryImage(card) {
    var images = card.querySelectorAll('.eclat-hover-img');
    if (images.length <= 1) return;
    images[1].classList.add('is-visible');
  }

  function showFeaturedImage(card) {
    var images = card.querySelectorAll('.eclat-hover-img');
    images.forEach(function (image) {
      image.classList.remove('is-visible');
    });
  }

  // Touch screens fire mouseenter on tap but never mouseleave, so the hover
  // image would stick (and survive Back via the bfcache). Only swap on real hover.
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.addEventListener('mouseenter', function (event) {
    if (!canHover.matches || !event.target.closest) return;
    var card = event.target.closest('.card-wrapper');
    if (card && card.querySelector('.eclat-hover-img')) showSecondaryImage(card);
  }, true);

  document.addEventListener('mouseleave', function (event) {
    if (!event.target.closest) return;
    var card = event.target.closest('.card-wrapper');
    if (card && card.querySelector('.eclat-hover-img')) showFeaturedImage(card);
  }, true);

  // Coming back with the Back button restores the page as it was left:
  // always show the featured image again.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.card-wrapper').forEach(showFeaturedImage);
  });
})();
